export default __webpack_public_path__ + "static/media/Edit.44f98df5.svg";